import Vue from 'vue'
import appConfig from "@src/app.config.json";
import router from "@router/index";
import VueGtag from "vue-gtag";

const AppGa = appConfig.ga;
Vue.use(VueGtag, {
  config: {
    id: '',
    // FIXME: 要改成正式 ga id
    // id: AppGa,
    // 56Q8W7G0BH
  },
}, router);
